"use strict";

exports.__esModule = true;
exports.StyledToolbarPageNav = exports.PreviousPageButton = exports.PageNavTotalPages = exports.PageNavSeparator = exports.PageNavEditInput = exports.PageNavEdit = exports.NextPageButton = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ToolbarButton = _interopRequireDefault(require("../ToolbarButton/ToolbarButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledToolbarPageNav = _styledComponents.default.div`
    display: flex;
`;
exports.StyledToolbarPageNav = StyledToolbarPageNav;
const PreviousPageButton = (0, _styledComponents.default)(_ToolbarButton.default)`
    margin-right: 0;
`;
exports.PreviousPageButton = PreviousPageButton;
const NextPageButton = (0, _styledComponents.default)(_ToolbarButton.default)`
    margin-left: 0;
`;
exports.NextPageButton = NextPageButton;
const PageNavEdit = _styledComponents.default.div`
    position: relative;
    width: 65px;
    height: 32px;
    border-bottom: 2px solid #ffffff;
    margin-top: 5px;
    padding-top: 3px;
    cursor: pointer;

    ${({
  theme
}) => theme.colors.pdfViewer.toolbar.icons && (0, _styledComponents.css)`
            border-bottom: 2px solid ${({
  theme
}) => theme.colors.pdfViewer.toolbar.icons};
        `};

    ${({
  options
}) => options.toolbarIconColor && (0, _styledComponents.css)`
            border-bottom: 2px solid ${options.toolbarIconColor};
        `};
`;
exports.PageNavEdit = PageNavEdit;
const PageNavEditInput = _styledComponents.default.input`
    position: absolute;
    top: 10px;
    display: block;
    width: 30px;
    height: 20px;
    background-color: transparent;
    color: inherit;
    font-size: 13px !important;
    line-height: 20px;
    font-weight: ${({
  theme
}) => theme.fontWeights.medium};
    padding-top: 0;
    padding-bottom: 0;
    padding-right: 2px;
    text-align: right;
    outline: none;
    cursor: pointer;
    border-radius: 0;
    border: none;
`;
exports.PageNavEditInput = PageNavEditInput;
const PageNavSeparator = _styledComponents.default.div`
    position: absolute;
    top: 10px;
    left: 30px;
    display: block;
    width: 8px;
    height: 20px;
    padding-right: 2px;
    font-size: 16px;
    line-height: 20px;
`;
exports.PageNavSeparator = PageNavSeparator;
const PageNavTotalPages = _styledComponents.default.div`
    position: absolute;
    top: 10px;
    left: 38px;
    display: block;
    width: 27px;
    height: 20px;
    font-size: 13px;
    line-height: 20px;
    font-weight: ${({
  theme
}) => theme.fontWeights.medium};

    // fix for ios layout
    @supports (-webkit-overflow-scrolling: touch) {
        transform: translateY(-0.5px);
    }
`;
exports.PageNavTotalPages = PageNavTotalPages;